import { createRoot } from 'react-dom/client';
import axios from 'axios';

import '@producer/ui-kit/tokens.css';
import '@producer/ui-kit/base.css';
import './ds-color-primitives.css';
import './ds-spacing-primitives.css';
import './ds-colors.css';
import './ds-typography.css';
import './index.css';
import 'tippy.js/dist/tippy.css';

import * as serviceWorker from './serviceWorker';
import { defaultConfig, globalConfig, globalConfigUrl } from './configuration/config';
import { api } from './api';
import { MixpanelProvider } from './wrappers/mixpanel';
import { initSentry } from './lib/sentry';
import { Cree8AuthProvider } from './cree8-auth';
import { AuthenticatedApp } from './AuthenticatedApp';

axios
  .get(`${window.location.origin}/${globalConfigUrl}`, {
    headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache', Expires: '0' },
  })
  .then((response) => {
    globalConfig.config = response.data;
  })
  .catch((e) => {
    if (process.env.NODE_ENV === 'development') {
      console.warn(`Failed to load '${globalConfigUrl}', using defaults:`, defaultConfig);
      globalConfig.config = defaultConfig;
    } else {
      const msg = 'Error while fetching global config, the App will not be rendered.';
      console.error(msg, `Have you provided '${globalConfigUrl}'?`, e);
      throw new Error(msg);
    }
  })
  .then(() => {
    if (process.env.NODE_ENV !== 'development') initSentry();
    api.init();

    const root = createRoot(document.getElementById('root')!);
    root.render(
      <Cree8AuthProvider>
        <MixpanelProvider>
          <AuthenticatedApp />
        </MixpanelProvider>
      </Cree8AuthProvider>,
    );
  })
  .catch((error) => {
    console.error('Unhandled error during app initialization:', error);
    const root = createRoot(document.getElementById('root')!);
    root.render(
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h1>Application Error</h1>
        <p>Failed to initialize the application. Please refresh the page.</p>
      </div>,
    );
  });

serviceWorker.unregister();
